export const selectFetchPromptTemplatesStatus = state => state.promptTemplates.status;
export const selectPromptTemplates = state => {
  return state.promptTemplates.templates;
};
export const selectFeaturedPromptTemplates = state => {
  return state.promptTemplates.featuredTemplates;
};
export const selectGroupedPromptTemplates = state => {
  return state.promptTemplates.groupedTemplates;
};
export const selectOrderedCategoryInfo = state => {
  return state.promptTemplates.orderedCategoryInfo || [];
};
export const selectFavoritePromptTemplates = state => {
  return state.promptTemplates.groupedTemplates && state.promptTemplates.groupedTemplates.FAVORITES;
};
export const selectedPromptTemplate = state => state.promptTemplates.selectedTemplate;
export const selectSelectedTemplateAction = state => state.promptTemplates.selectedTemplateAction;
export const selectDraftParameterValues = state => state.promptTemplates.draftParameterValues;
export const selectPrefillValues = state => state.promptTemplates.prefillValues;